module.exports = __webpack_public_path__ + "static/img/A13.9daa1286.jpg";